module.exports = __webpack_public_path__ + "img/xaas-payment.cd29dce.png";